// extracted by mini-css-extract-plugin
export default {"wrapper":"CreatePropertyInfo_wrapper__f3rzL","baseFlex":"CreatePropertyInfo_baseFlex__W0Nsf","refreshTag":"CreatePropertyInfo_refreshTag__+w2m6"};